<template>
  <div class="container page">
    <van-nav-bar :title="$t('q58')" class="nav-bar">
      <template #left>
        <van-icon name="arrow-left" @click="back()" />
      </template>
    </van-nav-bar>
  
    <div class="main">
   
      <van-pull-refresh v-model="isLoading" @refresh="onRefresh">
        <van-empty v-if="list.length === 0" :description="$t('withdraw.empty_data')" />
        <div v-else class="item_list" v-for="(v,key) in list" :key="key">
          <div class="lottery_info">
            <van-image class="cover" :src="v.ico">
              <template v-slot:loading>
                <van-loading type="spinner"/>
              </template>
            </van-image>
            <span class="period-number">{{v.expect}}</span>
            <span class="period-number">{{v.name}}</span>
          </div>
          <div class="recent">
            <div class="kuaisan-ball left">
            <div>
              <span>{{$t("reservation.result")}}</span>
              <span class="ressquareBox">{{ size }}</span>
              <span class="ressquareBox">{{ double }}</span>
             
            </div>
          
            </div>
          </div>
          <div class="topInfo">
        
            <span v-if="v.status === 1" style="color: #07c160">{{v.status_text}}</span>
            <span v-else>{{v.status_text}}</span>
            <span>{{$t("reservation.money")}}：{{v.money}}</span>
          </div>
       <!--   <div class="topInfo">
            <span v-if="v.is_win === 1" style="color: #07c160">{{v.win_text}}</span>
            <span v-else >{{v.win_text}}</span>
            <span>金额：{{v.profit}}</span>
          </div> -->
          <!-- <div class="topInfo">
            <span>任务类型：</span>
            <span>{{v.type}}</span>
          </div> -->
          <div class="time">
            <span>{{$t("reservation.order_time")}}：{{v.create_time}}</span>
          </div>
          <div class="time">
            <span>{{$t("reservation.settle_time")}}：{{v.update_time}}</span>
          </div>
        </div>
      </van-pull-refresh>
    </div>
  </div>
</template>

<script>
import { getStoredLang } from '../../utils/lang'
export default {
  data() {
    return {
      isLoading: false,
      list: [],
      sum: '',
      double: '',
      size:""
      
    };
  },
  methods: {
    back(){
      return window.history.back();
    },
    onRefresh() {
      setTimeout(() => {
        this.$toast(this.$t("reservation.refresh"));
        this.isLoading = false;
      }, 500);
    },
    getUserGameList(){
      this.$http({
        method: 'get',
        url: 'user_get_game_list'
      }).then(res=>{
        if(res.code === 200){
          const lanng = getStoredLang();
          this.list = res.data;
          this.list.forEach(item => {
          const sum = item.opencode[0] + item.opencode[1] + item.opencode[2];
            if(sum >= 11 && sum <=18){
            this.size = lanng === 'zh' ? '玫瑰' : (lanng === 'de' ? 'Rose' : (lanng === 'fr' ? 'Rose' : (lanng === 'it' ? 'Rosa' : 'Rose')))
          }else if(sum >= 3 && sum <= 10){
              this.size = lanng === 'zh' ? '百合' : (lanng === 'de' ? 'Lilie' : (lanng === 'fr' ? 'Lys' : (lanng === 'it' ? 'Giglio' : 'Lily')))
          }
          if(sum % 2 === 0){
            this.double = lanng === 'zh' ? '氣球' : (lanng === 'de' ? 'Ballon' : (lanng === 'fr' ? 'Ballon' : (lanng === 'it' ? 'Palloncino' : 'Balloon')));
          }else {
            this.double = lanng === 'zh' ? '煙花' : (lanng === 'de' ? 'Feuerwerk' : (lanng === 'fr' ? "Feu d'artifice" : (lanng === 'it' ? "Fuochi d'artificio" : 'Fireworks')));
          }
          })
        }else if(res.code ===401){
          this.$toast(res.msg);
        }
      })
    }

  },
  created() {
    if(!localStorage.getItem('token')){
      this.$router.push({path:'/Login'})
    }else {
      // this.getUserGameList();
    }
  },
  
};
</script>

<style lang='less' scoped>
@import "../../assets/css/base.css";
.item_list .cover{
  width: 40px;
  height: 40px;
  object-fit: cover;
  border-radius: 50%;
}
.item_list .period-number{
  margin-left: 12px;
  font-size: 14px;
  font-weight: 600;
  color: #333;
}
.item_list .lottery_info{
  display: flex;
  align-items: center;
  margin-bottom: 8px;
}
.recent {
  display: flex;
  align-items: center;
  margin-bottom: 8px;
}
.kuaisan-ball .left{ justify-content: flex-start; }
.kuaisan-ball{ flex: 1; display: flex; align-items: center; color: #666; font-size: 13px; }
.ressquareBox{
  background: linear-gradient(90deg, #f560cd, #4f2b8a);
  color: #fff;
  display: inline-block;
  text-align: center;
  font-size: 12px;
  font-weight: 600;
  border-radius: 8px;
  margin-left: 8px;
  padding: 4px 12px;
}
</style>
